import { Add } from '@mui/icons-material'
import { Avatar, AvatarGroup, IconButton } from '@mui/material'
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro'
import { GetRosterColorsQuery } from '__generated__/graphql'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'

interface ColorsAvatarGroupProps extends Partial<GridRenderCellParams> {
    colors: GetRosterColorsQuery['rosterColors']
    id: string
    disabled?: boolean
}

const ColorsAvatarGroup: FC<ColorsAvatarGroupProps> = ({
    colors,
    id,
    disabled = false,
}) => {
    const api = useGridApiContext()
    if (colors?.length === 0)
        return (
            <IconButton
                disabled={disabled}
                sx={{ marginLeft: `-${getPxAsRem(8)}`, padding: getPxAsRem(4) }}
                onClick={() =>
                    api.current.startCellEditMode({ id, field: 'colors' })
                }
            >
                <Add sx={{ fontSize: getPxAsRem(16) }} />
            </IconButton>
        )
    return (
        <AvatarGroup
            max={100}
            sx={{ width: 'fit-content', height: '100%', alignItems: 'center' }}
        >
            {colors
                .sort((colorA, colorB) => colorA.order - colorB.order)
                .map((color) => (
                    <Avatar
                        key={color.id}
                        sx={{
                            backgroundColor: color.hexCode,
                            width: getPxAsRem(16),
                            height: getPxAsRem(16),

                            svg: {
                                display: 'none',
                            },
                        }}
                    />
                ))}
        </AvatarGroup>
    )
}

export default ColorsAvatarGroup
